



import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage'
import "firebase/storage";



const firebaseConfig = {
 apiKey: "AIzaSyCpxUHw1fyyQqJy4XBfvE5othT0SFU6EIc",
  authDomain: "koffee-house-315ea.firebaseapp.com",
  projectId: "koffee-house-315ea",
  storageBucket: "koffee-house-315ea.firebasestorage.app",
  messagingSenderId: "794561234563",
  appId: "1:794561234563:web:f4c910b9f4b0efeccc3db6",
  measurementId: "G-MFKP127GV4"
};
//init firebase app
const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;



